import { render } from "./MyLists.vue?vue&type=template&id=07177313&scoped=true"
import script from "./MyLists.vue?vue&type=script&lang=js"
export * from "./MyLists.vue?vue&type=script&lang=js"

import "./MyLists.vue?vue&type=style&index=0&id=07177313&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07177313"]])

export default __exports__